import { MutableRefObject, useEffect, useRef } from 'react';

export function useClickOutside<Element = any>(
  handler: () => void,
  active = true,
  ms?: number
): MutableRefObject<Element> {
  const domNode = useRef(null);

  useEffect(() => {
    const maybeHandler = (event: any): void => {
      if (active && !domNode.current?.contains(event.target)) {
        if (ms) {
          setTimeout(() => {
            handler();
          }, ms);
        } else {
          handler();
        }
      }
    };

    document.addEventListener('mousedown', maybeHandler);

    return () => {
      document.removeEventListener('mousedown', maybeHandler);
    };
  });

  return domNode;
}
